import { add, parseISO, toDate } from 'date-fns';

export class ProgramIncrement {

  public id: number;
  public name: string;
  public goal: string;
  public dateStart: Date;
  public dateEnd: Date;
  public numberOfSprints: number;
  // Duration in days
  public sprintDuration: number;
  public sprintPrefix: string;
  public programId: number;


  constructor(id: number,
    name: string,
    goal: string,
    dateStart: Date,
    numberOfSprints: number,
    sprintDuration: number,
    sprintPrefix: string,
    programId: number) {
    this.id = id;
    this.name = name;
    this.goal = goal;
    this.dateStart = dateStart;
    this.numberOfSprints = numberOfSprints;
    this.sprintDuration = sprintDuration;
    this.sprintPrefix = sprintPrefix;
    this.programId = programId;
    this.dateEnd = add(new Date(this.dateStart), { days: (this.sprintDuration * numberOfSprints) });
  }



}
